import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import searchIcon from "../assets/admin/search.svg";

const STORAGE_KEY = "searchTexts";

const SearchInput = ({ onSearchChange, component, placeholder }) => {
    // Retrieve the stored object or fallback to an empty object
    const componentKey = `${component} Text`;
    const storedSearchTexts = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    const [searchText, setSearchText] = useState(storedSearchTexts[componentKey] || "");

    const handleSearchTextChange = (e) => {
        const value = e.target.value;
        // Prevent starting space
        if (value.length === 1 && value.startsWith(" ")) return;
        setSearchText(value);

        // Update the localStorage object
        const updatedSearchTexts = { ...storedSearchTexts, [componentKey]: value };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedSearchTexts));

        if (onSearchChange) {
            onSearchChange(value);
        }
    };

    useEffect(() => {
        const handlePageRefresh = () => {
            const updatedSearchTexts = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};

            // Remove only the current component's text
            delete updatedSearchTexts[componentKey];

            localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedSearchTexts));
        };

        window.addEventListener("beforeunload", handlePageRefresh);

        return () => {
            window.removeEventListener("beforeunload", handlePageRefresh);
        };
    }, [component, componentKey]);

    return (
        <div className="relative text-sm bg-transparent border border-gray-300 rounded-3xl w-full sm:w-full md:w-auto ">
            <div className="inline-flex justify-between items-center px-6 pl-8 py-[7px] sm:w-auto w-full outline-none text-[#8F8F8F] border border-[#D9D9D9] rounded-full shadow-sm">
                <img
                    src={searchIcon}
                    className="absolute left-3 top-0 bottom-0 my-auto h-4 w-4"
                    alt="Search"
                />
                <input
                    type="text"
                    placeholder={`Cerca ${placeholder}`}
                    value={searchText}
                    onChange={handleSearchTextChange}
                    className="outline-none poppins-medium w-full"
                />
            </div>
        </div>
    );
};
SearchInput.propTypes = {
    onSearchChange: PropTypes.func,
    component: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
};

export default SearchInput;
